import React from 'react';
import { X, Image, FilePdf, FileText } from '@phosphor-icons/react';
import { UploadResult } from '@Utils/FileAttachmentUtils';
import { getFileTypeInfo } from '@Utils/FileAttachmentUtils';

interface FileAttachmentDisplayProps {
  attachments: UploadResult[];
  onRemoveAttachment: (index: number) => void;
}

const FileAttachmentDisplay: React.FC<FileAttachmentDisplayProps> = ({
  attachments,
  onRemoveAttachment,
}) => {
  if (attachments.length === 0) return null;

  const getIcon = (iconType: string, iconColor: string) => {
    const iconProps = { size: 16, className: iconColor };

    switch (iconType) {
      case 'FilePdf':
        return <FilePdf {...iconProps} />;
      case 'FileText':
        return <FileText {...iconProps} />;
      case 'Image':
      default:
        return <Image {...iconProps} />;
    }
  };

  return (
    <div className="mb-2">
      <div className="mb-1 text-xs font-medium text-gray-600">
        Attached Files ({attachments.length}):
      </div>
      <div className="flex flex-wrap gap-2">
        {attachments.map((attachment, index) => {
          const fileTypeInfo = getFileTypeInfo(attachment.fileName);

          return (
            <div
              key={index}
              className={`flex items-center gap-2 rounded-lg ${fileTypeInfo.bgColor} px-3 py-1 text-sm`}
            >
              {getIcon(fileTypeInfo.icon, fileTypeInfo.iconColor)}
              <span className="max-w-40 truncate">{attachment.fileName}</span>
              <button
                onClick={() => onRemoveAttachment(index)}
                className="text-red-500 hover:text-red-700"
              >
                <X size={16} />
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FileAttachmentDisplay;
